import Vue from 'vue';

Vue.directive('checkRole', {
  inserted: function(el, binding, vnode) {
    const role = vnode.context.$route.meta.role;
    if (role !== 2) {
      el.parentNode.removeChild(el);
    }
  }
});

Vue.directive('checkElseRole', {
  inserted: function(el, binding, vnode) {
    const role = vnode.context.$route.meta.role;
    if (role == 2) {
      el.parentNode.removeChild(el);
    }
  }
});

Vue.directive("loadmore", {
  bind(el, binding) {
    // 获取element-ui定义好的scroll盒子
    const SELECTWRAP_DOM = el.querySelector(
      ".el-select-dropdown .el-select-dropdown__wrap"
    );
    SELECTWRAP_DOM.addEventListener("scroll", function() {
      const CONDITION =
        this.scrollHeight - this.scrollTop === this.clientHeight;
      if (CONDITION) {
        binding.value();
      }
    });
  }
});




